module.exports = __webpack_public_path__ + "assets/img/classification.541a4c4d.png";